import { FunctionComponent } from "react";
import ApolloPage from "../../components/ApolloPage/ApolloPage";
import styles from "./InProgress.module.css";
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";

const InProgress: FunctionComponent = () => {

    return <ApolloPage loading={false} needsLogin={false} >
        <div className={styles.mainErrorContainer}>
            <img
                className={styles.imageIcon}
                src={(process.env.PUBLIC_URL ?? "") + "/assets/InProgress.png"}
                alt="Oops !"
            />
            <Title level={1} prefix={i18n.t('title.inprogress.wip')} content={i18n.t('title.inprogress.comingsoon')} />
        </div>
    </ApolloPage>
};

export default InProgress;